import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {
    AssetCouponValueObject
} from "../../../data/value-object/asset/AssetCouponValueObject";
import {
    AssetCouponSearchOption
} from "../../../data/search-option/asset/AssetCouponSearchOption";
import {searchIndex, SearchIndex} from "../../../io/HttpClient";
import ListPageWrapper from "../../ListPageWrapper";
import {AssetCouponIO} from "../../../io/AssetIO";
import {AssetCouponDescription} from "../../../data/description/asset/AssetCouponDescription";
import {AssetCouponDescriptor} from "../../../data/descriptor/asset/AssetCouponDescriptor";
import ListOption from "../../ListOption";
import {
    AssetCouponSearchOptionDescription
} from "../../../data/description/asset/AssetCouponSearchOptionDescription";
import {
    applyAssetCouponSearchOption,
    AssetCouponSearchOptionField
} from "../../search-option-field/asset/AssetCouponSearchOptionField";
import ListOrder from "../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<AssetCouponValueObject[]>([])
    const option = useStatePair<AssetCouponSearchOption>({})
    const index = useStatePair<SearchIndex>(searchIndex())

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={AssetCouponIO}
                items={items}
                option={option.value}
                index={index}
                description={AssetCouponDescription}
                descriptor={AssetCouponDescriptor}
                showPost
                onPostClick={() => document.location = '/assets/coupons/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/assets/coupons/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={AssetCouponSearchOptionDescription}
                fields={AssetCouponSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyAssetCouponSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={AssetCouponDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}